import React, { FC } from 'react';
import { isArray } from 'lodash';
import { ICellRendererParams } from 'ag-grid-community';
import { Counter, NoValuePlaceholder } from '@aleph/shared-components';
import { useTranslation } from 'react-i18next';

type MultiValueCellRendererProps = {
	disabled?: boolean
	labelGetter?: (value: unknown) => string
} & ICellRendererParams;

const MultiValueCellRenderer: FC<MultiValueCellRendererProps> = (params) => {
	const { value, labelGetter } = params;
	const { t } = useTranslation();

	if (
		params.disabled
	) {
		return <NoValuePlaceholder />;
	}

	return (
		<div className="px-[8px] h-full w-full flex items-center gap-[8px]">
			{
				(!isArray(value) || value?.length === 0) && <span>{t('sc: any', 'Any')}</span>
			}

			{
				isArray(value) && value?.length > 0
					&& <>
						<div className="overflow-hidden flex-1 overflow-ellipsis">
							{value.map(labelGetter ?? (val => val?.label ?? 'Unknown')).join(', ')}
						</div>
						<Counter
							className="relative"
							count={value.length}
							variant="square-subtle"
						/>
					</>
			}
		</div>
	);
};

export default MultiValueCellRenderer;
